<template>
  <div class="cover">
    <!-- <div class="head align-center justify-end">
      <div class="menu">
        <div v-for="(item, index) in menuList" :key="item.url">
          <img
            :style="
              menuType == index && {
                transform: 'scale(1.5)',
                marginTop: '0.6rem',
              }
            "
            :src="
              '/static/img/intr/' +
              (menuType == index ? item.activeUrl : item.url) +
              '.png'
            "
            @click="menuType = index"
          />
        </div>
      </div>
    </div> -->
    <div class="head justify-end">
      <div class="headcontent">
        <div class="topimg">
          <img src="/static/img/intrnew/banner.png" alt="" />
        </div>
        <div class="bottomlist">
          <ul>
            <li @click="menuType = 0">
              <img src="/static/img/intrnew/jiantou_zuo.png" alt="" /><span
                >概况</span
              ><img src="/static/img/intrnew/jiantou_you.png" alt="" />
            </li>
            <li @click="menuType = 1">
              <img src="/static/img/intrnew/jiantou_zuo.png" alt="" /><span
                >總編纂</span
              ><img src="/static/img/intrnew/jiantou_you.png" alt="" />
            </li>
            <!-- <li @click.stop>
              <img src="/static/img/intrnew/jiantou_zuo.png" alt="" /><span
                class="huise"
                >編纂與出版</span
              ><img src="/static/img/intrnew/jiantou_you.png" alt="" />
            </li>
            <li @click.stop>
              <img src="/static/img/intrnew/jiantou_zuo.png" alt="" /><span
                class="huise"
                >部類主編</span
              ><img src="/static/img/intrnew/jiantou_you.png" alt="" />
            </li> -->
            <li @click="menuType = 6">
              <img src="/static/img/intrnew/jiantou_zuo.png" alt="" /><span
                >編委會</span
              ><img src="/static/img/intrnew/jiantou_you.png" alt="" />
            </li>
            <li @click="menuType = 4">
              <img src="/static/img/intrnew/jiantou_zuo.png" alt="" /><span
                >凡例</span
              ><img src="/static/img/intrnew/jiantou_you.png" alt="" />
            </li>
            <!-- 精華編 -->
          </ul>
        </div>
      </div>
    </div>

    <div class="intr-info" v-if="menuType == 0">
      <!-- <h1 class="title">《儒藏》概况</h1> -->
      <div class="intr-content">
        <div
          v-html="gaikuang.articleContent"
          class="ql-editor new-editor"
        ></div>
        <!-- <p>
          《儒藏》工程是我國建國以來最大規模地系統整理海内外儒學典籍的一項基礎性文化建設工程。
          工程依託北京大學深厚的文化底藴和優秀的學術傳統，聯合國内及韓、日、越三國近百所高校和學術機構近500名學者，致力於儒家文獻的系統整理與研究，旨在以現代的學術眼光和科技手段，采用繁體校點排印及進一步數位化的管道，將中、韓、日、
          越四國的儒家典籍文獻集大成地編纂成爲一個經過審慎校勘、規範標點的獨立的文獻體系，爲全世界各國學者提供一套文字可靠、閲讀方便、檢索便捷的儒家文獻版本，嘉惠學林，涵育未來世界的文化生機。
        </p>
        <p>
          《儒藏》工程是教育部哲學社會科學研究重大課題攻關項目、國家社會科學基金重大專案、國家哲學社會科學研究“十一五”規劃、“十一五”國家重點圖書出版規劃項目·重大工程出版規劃、“十二五”國家重點圖書出版規劃項目·重大工程出版規劃、北京大學“985工程”重點專案。
        </p>
        <p>
          《儒藏》工程分兩步實施。
          先期成果“精華編”將中國歷史上最具影響力和代表性的儒學文獻——包括傳世文獻和出土文獻500餘種及韓、日、越三國歷史上用漢文著述的100餘種儒學文獻萃爲一編，編成339册（其中中國部分282册，韓國37册，日本18册，越南2册）。
          第二步《儒藏》全本收書規模將會大大增加，初步估計收書在3000種以上（含“精華編”），將基本囊括中、韓、日、越四國歷史上比較有價值的儒學著作。
        </p>
        <p>
          《儒藏》工程的實施，不僅標誌著中國以儒家思想爲核心的兩千多年的文化傳統第一次得以全面整理，中國進入了一個返本開新、對傳統重新理解的全新時代，同時也標誌著東亞儒家文化圈各國對深受儒家文化影響的本民族文化傳統的新的認識和理解。
          以《儒藏》編纂爲契機，不同國家和地區的學者共同整理和思考儒學傳統，藉此加强相互間的理解與尊重。
        </p> -->
      </div>
    </div>

    <div class="intr-info main-edite" v-if="menuType == 1">
      <h1 class="title">
        <span class="touming">《儒藏》總編纂</span>
      </h1>

      <div class="intr-content content flex">
        <div class="big-img-box">
          <img :src="'/static/img/intr/' + editeList[editeSlt].img" />
        </div>
        <div class="peopel-info">
          <div>
            <div class="name">{{ editeList[editeSlt].name }}</div>
            <div class="role">{{ editeList[editeSlt].role }}</div>
          </div>
          <div class="job" v-html="editeList[editeSlt].job"></div>
          <div class="img-box">
            <div
              v-for="(item, index) in editeList"
              :key="item.img"
              @click="editeSlt = index"
            >
              <img :src="'/static/img/intr/' + item.img" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="intr-info" v-if="menuType == 2">
      <div class="people-list cover">
        <h1 class="title" style="padding-bottom: 0"></h1>

        <div class="intr-content people" style="width: 80rem">
          <img src="/static/img/intr/zhubianbiao.png" />
        </div>
      </div>
    </div>
    <div class="intr-info" v-if="menuType == 3">
      <div class="people-list cover">
        <h1 class="title" style="padding-bottom: 0">《儒藏》精華編部類主編</h1>

        <div class="intr-content people" style="width: 80rem">
          <img src="/static/img/intr/zhubianbiao1.png" style="width: 80rem" />
        </div>
      </div>
    </div>

    <div class="intr-info" v-if="menuType == 4">
      <!-- <h1 class="title">《儒藏》精華編凡例</h1> -->
      <div class="intr-content">
        <div v-html="fanlie.articleContent" class="ql-editor new-editor"></div>
        <!-- <p>
          一、中國傳統文化以儒家思想爲中心。
          《儒藏》爲儒家經典和反映儒家思想、體現儒家經世做人原則的典籍的叢編。
          收書時限自先秦至清代結束。
        </p>
        <p>二、《儒藏》精華編爲《儒藏》的一部分，選收《儒藏》中的精要書籍。</p>
        <p>
          三、《儒藏》精華編所收書籍，包括傳世文獻和出土文獻。
          傳世文獻按《四庫全書總目》經史子集四部分類法分類，大類、小類基本參照《中國叢書綜錄》和《中國古籍善本書目》，於個別處略作調整。
          凡單書已收入入選的個人叢書或全集者，僅存目錄，並注明互見。
          出土文獻單列爲一個部類，原件以古文字書寫者一律收其釋文文字。
          韓國、日本、越南儒學者用漢文寫作的儒學著作，編爲海外文獻部類。
        </p>
        <p>
          四、所收書籍的篇目卷次，一仍底本原貌，不選編，不改編，保持原書的完整性和獨立性。
        </p>
        <p>
          五、對入選書籍進行簡要校勘。
          以對校爲主，確定内容完足、精確率高的版本爲底本，精選有校勘價值的版本爲校本。
          出校堅持少而精，以校正誤爲主，酌校异同。 校記力求規範、精煉。
        </p>
        <p>
          六、根據現行標點符號用法，結合古籍標點通例，進行規範化標點。
          專名號除書名號用角號（《》）外，其他一律省略。
        </p>
        <p>
          七、對較長的篇章，根據文字内容，適當劃分段落。
          正文原已分段者，不作改動。 千字以内的短文一般不分段。
        </p>
        <p>
          八、各書卷端由整理者撰寫《校點說明》，簡要介紹作者生平、該書成書背景、主要内容及影響，以及整理時所確定的底本、校本（舉全稱後括注簡稱）及其他有關情况。
          重複出現的作者，其生平事蹟按出現順序前詳後略。
        </p>
        <p>九、本書用繁體漢字豎排，小注一律排爲單行。</p> -->
      </div>
    </div>

    <div class="intr-info thank" v-if="menuType == 5">
      <h1 class="title" style="padding-bottom: 0">《儒藏》精華編鳴謝</h1>
      <div class="desc">
        《儒藏》精華編惠蒙善助，共襄斯文； 謹列如下，用伸謝忱。
      </div>
      <div class="intr-content people" style="width: 100%; padding-left: 10rem">
        <div v-for="item in peopleList" :key="item">
          <div>{{ getStr(item, 0) }}</div>
          <div>{{ getStr(item, 1) }}</div>
        </div>
      </div>
      <div class="center foot">北京大學《儒藏》編纂與研究中心</div>
    </div>
    <div class="intr-info" v-if="menuType == 6">
      <!-- <h1 class="title">《儒藏》精華編凡例</h1> -->
      <div class="intr-content">
        <div v-html="bianwei.articleContent" class="ql-editor new-editor"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { readHistory, getArticleDetailByName } from "@/api/api"
export default {
  name: "WordTest",
  components: {},
  data () {
    return {
      menuType: 0,
      menuList: [
        {
          url: "gaikuang",
          activeUrl: "gaikuang-active"
        },
        {
          url: "zongbianzuan",
          activeUrl: "zongbianzuan-active"
        },
        {
          url: "buleizhubian",
          activeUrl: "buleizhubian-active"
        },
        {
          url: "buleizhubian1",
          activeUrl: "buleizhubian-active1"
        },
        {
          url: "fangli",
          activeUrl: "fangli-active"
        },
        // {
        //   url: "mingxie",
        //   activeUrl: "mingxie-active"
        // }

      ],
      peopleList: [
        "本煥法師,壹佰萬元",

        "智海企業集團董事長馮建新先生,壹佰萬元",

        "NE·TIGER時裝有限公司董事長張志峰先生,壹佰萬元",

        "張貞書女士,壹佰萬元",

        "付剛先生,伍拾萬元",

        "王明亮先生,貳拾萬元",

        "北京星河園林景觀工程有限公司董事長陳子舟先生,拾萬元",

        "北京三智文化書院高斌先生,拾萬元",

        "華府置業董事長鄂俊宇先生,拾萬元",

        "北京天創盛世数位科技有限公司周洲先生,拾萬元",

        "國藥控股海南有限公司董事黃培瑩女士,拾萬元",

        "愛沃克（北京）廣告傳媒有限公司趙思佳女士,拾萬元",

        "文哲先生,拾萬元",

        "北京華房美泰建築裝飾工程有限公司董事長葉騰飛先生,伍萬元",

        "中韻鑄寶（北京）文化有限公司董事長王櫟硯先生,伍萬元",

        "江蘇萬和文化集團董事長謝咏禾先生,伍萬元",

        "瀋陽人和機電工程設備有限公司董事長劉斌先生,伍萬元",

        "劉靜女士,伍萬元",

        "邵敏同女士,伍萬元",

        "宋軍生先生,伍萬元",

        "寧述勇先生,伍萬元"
      ],
      editeSlt: 0,
      editeList: [
        {
          img: "1.png",
          name: "季羡林",
          role: "《儒藏》首席總編纂",
          job: "國學大師<br/>資深院士<br/>北京大學資深教授"
        },
        {
          img: "2.png",
          name: "湯一介",
          role: "《儒藏》項目首席專家，總編纂",
          job: "北京大學《儒藏》編撰與研究中心首任主任<br/>北京大學哲學系資深教授"
        },
        {
          img: "3.jpg",
          name: "《儒藏》總編纂合影",
          role: "左起：孫欽善教授 龐樸教授 湯一介教授 安平秋教授"
        }
      ],
      gaikuang: {},
      fanlie: {},
      bianwei: {}
    }
  },
  mounted () {
    this.getArticleDetail('概况')
    this.getArticleDetail('凡例')
    this.getArticleDetail('編委會')
  },
  methods: {
    getStr (item, index) {
      return item.split(",")[index]
    },
    getArticleDetail (name) {
      getArticleDetailByName(name).then(d => {
        // console.log(d, 'ddd')
        let e = d.data || {}
        e.articleContent = e.articleContent ? e.articleContent.replace(/src="\/prod-api/g, 'src="' + this.baseUrl) : ''
        if (name == '概况') {
          this.gaikuang = e
        } else if (name == '凡例') {
          this.fanlie = e
        } else if (name == '編委會') {
          this.bianwei = e
        }


      })
    },
  }
};
</script>

<style lang="less" scoped>
.touming {
  opacity: 0;
}
.huise {
  color: #ccc;
}
.new-editor {
  text-align: justify;
}
.cover {
  margin: 0 auto;
  // padding: 3rem 0;
  .head {
    width: 100%;
    height: 445.6px;
    box-sizing: border-box;
    background: url(/static/img/intrnew/banner_bg.png) 0 0 no-repeat;
    background-size: 100% 445.6px;
    // background-size: 100% 38.9375rem;
    position: relative;
    .headcontent {
      width: 1200px;
      margin: 0 auto;
      .topimg {
        width: 150px;
        margin-top: 94px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .bottomlist {
        width: 100%;
        margin-top: 40px;
        ul {
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: 0;
          li {
            list-style: none;
            cursor: pointer;
            color: #fff;
            font-size: 34px;
            font-weight: 600;
            display: flex;
            align-items: center;
            img {
              width: 17px;
              height: 31px;
            }
            span {
              margin: 0 10px;
            }
          }
        }
      }
    }

    .menu {
      // position: absolute;
      right: 11rem;
      margin-right: 11rem;

      bottom: 3.7rem;
      width: 37.66rem;
      height: 15.3rem;
      background: url(/static/img/intr/bg.png) no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;

      padding: 2rem 1rem;
      padding-right: 3rem;
      img {
        width: 2.5rem;
        height: auto;

        cursor: pointer;
      }
      > div {
        flex: 1;
        text-align: center;
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5) {
          > img {
            width: 4.58rem;
          }
        }
      }
    }
  }

  .title {
    padding: 3rem 0;
    font-size: 2.5rem;

    font-weight: bold;
    color: #314370;
    text-align: center;
    margin: 0;
  }

  .intr-info {
    background: rgba(240, 248, 255, 0.5) url(/static/img/intr/outer-bg.png);
    background-size: 100% 100%;
    min-height: ~"calc(100% - 350px)";
    position: relative;
    padding-bottom: 5rem;
  }
  .intr-content {
    width: 63.5rem;

    font-size: 1.25rem;
    color: #314370;
    margin: 0 auto;

    p {
      margin: 0 0 1.5rem;
      line-height: 2rem;
      text-indent: 2.5rem;
    }
  }

  .thank {
    .desc {
      font-size: 1.56rem;

      color: #314370;
      margin: 1.8rem auto 3.5rem;
      text-align: center;
    }
    .people {
      > div {
        display: flex;
        > div {
          display: flex;
          flex: 1;
          font-size: 1.56rem;

          color: #314370;
          margin-bottom: 0.5rem;
          &:first-child {
            justify-content: flex-end;
          }
          &:last-child {
            padding-left: 3rem;
          }
        }
      }
    }
    .foot {
      font-size: 1.25rem;

      font-weight: bold;
      color: #314370;
      margin: 3rem 0;
    }
  }

  .people-list {
    // background: url(/static/img/intr/people-bg.png);
    // background-size: 100% auto;

    img {
      width: 52rem;
      margin: 2rem 0;
      display: block;
      margin: 0 auto;
    }
  }
  .main-edite {
    margin-bottom: 12rem;
    width: 100%;

    .content {
      width: 100%;
      padding: 0 5.5rem;
      height: 30.5rem;
      color: #314370;
      background: rgba(240, 248, 255, 0.5) url(/static/img/edite-bg.png) !important;
      background-size: 100% 36rem !important;
      .big-img-box {
        width: 29.78rem;

        img {
          width: 100%;
          margin-top: -4.8rem;
        }
      }
      .peopel-info {
        padding-left: 1.56rem;
        display: flex;
        flex: 1;
        flex-grow: 1;
        flex-direction: column;
        justify-content: space-between;
        .name {
          font-size: 3.13rem;

          font-weight: bold;

          padding: 0.5rem;
        }
        .role {
          font-size: 1.35rem;
        }
        .job {
          font-size: 1.15rem;
          padding-top: 1rem;
        }
        .img-box {
          display: flex;
          height: 12rem;
          > div {
            margin-right: 1rem;
            position: relative;

            flex: 2;
            &:last-child {
              flex: 3;
            }
            > img {
              position: absolute;
              width: 100%;
              height: 17rem;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/intrInfo/productInfo.vue